import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

export const PageHeader = ({ 
  title, 
  subtitle, 
  actions,
  className 
}) => {
  return (
    <div 
      className={cn(
        "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8",
        className
      )}
      data-testid="page-header"
    >
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-[-0.02em] text-cloud-white">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-soft-silver text-sm sm:text-base">
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-3" data-testid="page-header-actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
